import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { flatMap, map } from 'rxjs/operators';
import { InspectionFactoryService } from '../../../shared/services/inspectionFactory.service';
import { ApiService, DataService, InspectionPluginService } from '../../../shared/services';
import { InspectionPlugin } from '../../../shared/models/index';

@Injectable()
export class InstallationDatePluginService extends InspectionPluginService {
  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private inspectionFactory: InspectionFactoryService
  ) {
    super(apiService, dataService, null);
  }

  public updateDates(inspectionId: string, pointId: string, pluginId: string, dates: any[]): Observable<any> {
    return this.update(inspectionId, pointId, pluginId, dates).pipe(
      map((res: InspectionPlugin) => {
        this.dataService.setChangedPoint(pointId);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  private update(inspectionId: string, pointId: string, pluginId: string, dates: any[]): Observable<any> {
    return this.inspectionFactory.updatePluginConfig(inspectionId, pointId, pluginId, dates, 'Dates').pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
